<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import AsyncSelect from '$components/Form/AsyncSelect.svelte';

    import {
        loadOptions,
        optionToValue,
        valueToId,
        valueToOption,
    } from '$components/Form/SelectJobTitle/utils';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, number | null>;
    export let placeholder: string = "Secteur d'activité";
    export let defaultClass: string | undefined = undefined;
    export let id: string | null = null;

    export let showChevron = false;

    let className: string = '';
    export { className as class };

    const { apollo } = getContainer();
</script>

<AsyncSelect
    {defaultClass}
    class={className}
    {form}
    {field}
    {placeholder}
    {id}
    loadOptions={(q) => loadOptions(apollo, q)}
    {optionToValue}
    valueToOption={(v) => valueToOption(apollo, v)}
    {valueToId}
    {showChevron}
    optionId="id"
    label="name"
>
    <div
        slot="option"
        let:option
        class="flex gap-[8px] py-[4px] pr-[8px] pl-[16px] rounded-[8px] w-full max-w-full items-center"
    >
        <div
            class="whitespace-normal line-clamp-2 font-normal text-13/[18px] tracking-[-1%] text-black"
        >
            {option.name}
        </div>
    </div>
</AsyncSelect>
